'use client';

import { useRef, useState, ReactNode } from 'react';

interface Card3DTiltProps {
  children: ReactNode;
  className?: string;
  intensity?: number;
}

export default function Card3DTilt({
  children,
  className = '',
  intensity = 15
}: Card3DTiltProps) {
  const cardRef = useRef<HTMLDivElement>(null);
  const [transform, setTransform] = useState('');
  const [glow, setGlow] = useState({ x: 50, y: 50 });

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;

    const card = cardRef.current;
    const rect = card.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * -intensity;
    const rotateY = ((x - centerX) / centerX) * intensity;

    setTransform(
      `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`
    );

    setGlow({
      x: (x / rect.width) * 100,
      y: (y / rect.height) * 100,
    });
  };

  const handleMouseLeave = () => {
    setTransform('perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)');
    setGlow({ x: 50, y: 50 });
  };

  return (
    <div data-component-id="src/components/effects/Card3DTilt.tsx:51:4" data-component-path="src/components/effects/Card3DTilt.tsx" data-component-line="51" data-component-end-line="70" data-component-file="Card3DTilt.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={`relative transition-all duration-300 ease-out ${className}`}
      style={{
        transform,
        transformStyle: 'preserve-3d',
      }}
    >
      {/* Glow effect that follows mouse */}
      <div data-component-id="src/components/effects/Card3DTilt.tsx:62:6" data-component-path="src/components/effects/Card3DTilt.tsx" data-component-line="62" data-component-end-line="67" data-component-file="Card3DTilt.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%20opacity-0%20group-hover%3Aopacity-100%20transition-opacity%20duration-500%20rounded-xl%22%7D"
        className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl"
        style={{
          background: `radial-gradient(600px circle at ${glow.x}% ${glow.y}%, rgba(200, 169, 126, 0.15), transparent 40%)`,
        }}
      />

      {children}
    </div>
  );
}
